
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ordersB0j_pjYmcDlByrMctIMU5TPpbwaW6UnT2lRAGI8PV30Meta } from "/app/frontend/src/pages/orders.vue?macro=true";
import { default as indexyf_ROjeerDGp7QPXz6i9WRLNI_Q2ppjWZflSWezYB9QMeta } from "/app/frontend/src/pages/users/self/index.vue?macro=true";
import { default as security4GPQdLnVg9vKOZCgxKe_45wx8qFaca3JFwntrw3vedlToMeta } from "/app/frontend/src/pages/users/self/security.vue?macro=true";
import { default as apitokensZXTfysMf5ayvfmzMXpGfO4T_457ttAqFlSD1waNvu9eB8Meta } from "/app/frontend/src/pages/users/self/apitokens.vue?macro=true";
import { default as selfFyxly4iQsYnmCeLIxzVKZV8pJE01Wbv6JQ0kuxgTP4EMeta } from "/app/frontend/src/pages/users/self.vue?macro=true";
import { default as development0mcokhrQfVFeXXI1CnVP13BpcmbfefXTS_45PEbL0WfwcMeta } from "/app/frontend/src/pages/development.vue?macro=true";
import { default as get_45startedwud6m1Z_v_USXaZi0tmQWNodHJPG3Cqwt2VVG7YRegsMeta } from "/app/frontend/src/pages/get-started.vue?macro=true";
import { default as indexb6rWTZPeAkq888o91RvXlzv_45_Nq5MZi5CqLybdCvJsoMeta } from "/app/frontend/src/pages/login/index.vue?macro=true";
import { default as indexrRIzPKWUnP11eM8qEGYwq2pM3wyeNWsHzXam6V9Xl68Meta } from "/app/frontend/src/pages/users/index.vue?macro=true";
import { default as data_45privacyTl7X2h2UBn1u_NwzuyXOQB72bxnK8zp7oGBT_45ix2ndUMeta } from "/app/frontend/src/pages/data-privacy.vue?macro=true";
import { default as reauthwYD2I0XBMpFJ20yiktnPmJ0xaOD5x_45Gu1qQNFIPonKkMeta } from "/app/frontend/src/pages/login/reauth.vue?macro=true";
import { default as index2vP9puIEHqXrQBb5OYSxoigZ05muCvHWzx5_45Sv9leI8Meta } from "/app/frontend/src/pages/lookup/index.vue?macro=true";
import { default as index7RnH2svK_45_45j1SLsjp8R9ymzjvTx7w6S7UDWoKKiAo3MMeta } from "/app/frontend/src/pages/domains/index.vue?macro=true";
import { default as newRYCU3vXtcTphkMWbW9m215FwE0eiBSX7kZ9hrqXmrUcMeta } from "/app/frontend/src/pages/leakprofiles/new.vue?macro=true";
import { default as _91domainId_930oPRxqYVz3xCpGQ1yNwOxlKQjLERkgEwpl_S38yAzL8Meta } from "/app/frontend/src/pages/lookup/[domainId].vue?macro=true";
import { default as faqsw8_RZypFhT9wjqhX8nxHgQt9mFiEsdFZAI2_KY33Xe0Meta } from "/app/frontend/src/pages/(landingpage)/faqs.vue?macro=true";
import { default as indexGqbC_45ZNI5BUOVgKwofbZ1LrViv2CexNDtFeow8Zt0rsMeta } from "/app/frontend/src/pages/leakprofiles/index.vue?macro=true";
import { default as set_45passwordhAyinGqJe61S3rMqA78CT5LtdT48Msc3_2orC7gagNsMeta } from "/app/frontend/src/pages/users/set-password.vue?macro=true";
import { default as index27N45u_45ujOyP0JnEvmiU8FEzaYL1GtgQ1Kr3bQhpPwkMeta } from "/app/frontend/src/pages/(landingpage)/index.vue?macro=true";
import { default as pricingk0K7K0MYjPIGInwKT0Iru4GMKhSWpip2SCGoVvfcdmEMeta } from "/app/frontend/src/pages/(landingpage)/pricing.vue?macro=true";
import { default as forgot_45passwordN2UHbbAsrzjdqpR_45N29wbv_45NBoEHO_IW9h8axX9eI9UMeta } from "/app/frontend/src/pages/login/forgot-password.vue?macro=true";
import { default as indexNnaILO72VcAvhXGDi84sJpjuKNbOJH5OEqjsWS7k944Meta } from "/app/frontend/src/pages/(landingpage)/signup/index.vue?macro=true";
import { default as indexKWOhxd7q6bmhrrWbOfK2GVO7ZuWchmudLiw9LiM9zHwMeta } from "/app/frontend/src/pages/leakprofiles/[leakprofileId]/index.vue?macro=true";
import { default as reportsqwiD8zGFXe_458Iyxy4CkPKL70EdGUl540uAU2wzTPNngMeta } from "/app/frontend/src/pages/leakprofiles/[leakprofileId]/reports.vue?macro=true";
import { default as accounts7ZhY8xlkEonF3xzdNGOiqpFOn4j959gFGAHkfvv43vMMeta } from "/app/frontend/src/pages/leakprofiles/[leakprofileId]/accounts.vue?macro=true";
import { default as csveditorMoEJIcq5NEJAHE3TYCmvlB9fOUsElE7INkLfVG7JkpQMeta } from "/app/frontend/src/pages/leakprofiles/[leakprofileId]/csveditor.vue?macro=true";
import { default as indexL6Rk_45LUpYgSQHW91ajj2cxSC9Lj2SfvrHnLCONYZJikMeta } from "/app/frontend/src/pages/leakprofiles/[leakprofileId]/alerts/index.vue?macro=true";
import { default as terms_45of_45service_45free_OPmlhbDawoRoAlZOQcYdfWwvWt6wJBXghbVru7AsAQMeta } from "/app/frontend/src/pages/(landingpage)/signup/terms-of-service-free.vue?macro=true";
import { default as _91alertId_93Dwwdl2NDUILMxx56mfqsIQnbE6s8j8LrmdmoGvg_45Wg8Meta } from "/app/frontend/src/pages/leakprofiles/[leakprofileId]/alerts/[alertId].vue?macro=true";
import { default as unsubscribeXQ0njCTFBwYiKUUXXfi5YwV8KBdJYQsEVZNnu4hdaFIMeta } from "/app/frontend/src/pages/leakprofiles/[leakprofileId]/alerts/unsubscribe.vue?macro=true";
export default [
  {
    name: "orders",
    path: "/orders",
    component: () => import("/app/frontend/src/pages/orders.vue")
  },
  {
    name: selfFyxly4iQsYnmCeLIxzVKZV8pJE01Wbv6JQ0kuxgTP4EMeta?.name,
    path: "/users/self",
    component: () => import("/app/frontend/src/pages/users/self.vue"),
    children: [
  {
    name: "users-self",
    path: "",
    component: () => import("/app/frontend/src/pages/users/self/index.vue")
  },
  {
    name: "users-self-security",
    path: "security",
    component: () => import("/app/frontend/src/pages/users/self/security.vue")
  },
  {
    name: "users-self-apitokens",
    path: "apitokens",
    component: () => import("/app/frontend/src/pages/users/self/apitokens.vue")
  }
]
  },
  {
    name: "development",
    path: "/development",
    component: () => import("/app/frontend/src/pages/development.vue")
  },
  {
    name: "get-started",
    path: "/get-started",
    component: () => import("/app/frontend/src/pages/get-started.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexb6rWTZPeAkq888o91RvXlzv_45_Nq5MZi5CqLybdCvJsoMeta || {},
    component: () => import("/app/frontend/src/pages/login/index.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexrRIzPKWUnP11eM8qEGYwq2pM3wyeNWsHzXam6V9Xl68Meta || {},
    component: () => import("/app/frontend/src/pages/users/index.vue")
  },
  {
    name: "data-privacy",
    path: "/data-privacy",
    meta: data_45privacyTl7X2h2UBn1u_NwzuyXOQB72bxnK8zp7oGBT_45ix2ndUMeta || {},
    component: () => import("/app/frontend/src/pages/data-privacy.vue")
  },
  {
    name: "login-reauth",
    path: "/login/reauth",
    meta: reauthwYD2I0XBMpFJ20yiktnPmJ0xaOD5x_45Gu1qQNFIPonKkMeta || {},
    component: () => import("/app/frontend/src/pages/login/reauth.vue")
  },
  {
    name: "lookup",
    path: "/lookup",
    component: () => import("/app/frontend/src/pages/lookup/index.vue")
  },
  {
    name: "domains",
    path: "/domains",
    meta: index7RnH2svK_45_45j1SLsjp8R9ymzjvTx7w6S7UDWoKKiAo3MMeta || {},
    component: () => import("/app/frontend/src/pages/domains/index.vue")
  },
  {
    name: "leakprofiles-new",
    path: "/leakprofiles/new",
    component: () => import("/app/frontend/src/pages/leakprofiles/new.vue")
  },
  {
    name: "lookup-domainId",
    path: "/lookup/:domainId()",
    component: () => import("/app/frontend/src/pages/lookup/[domainId].vue")
  },
  {
    name: "faqs",
    path: "/faqs",
    meta: faqsw8_RZypFhT9wjqhX8nxHgQt9mFiEsdFZAI2_KY33Xe0Meta || {},
    component: () => import("/app/frontend/src/pages/(landingpage)/faqs.vue")
  },
  {
    name: "leakprofiles",
    path: "/leakprofiles",
    component: () => import("/app/frontend/src/pages/leakprofiles/index.vue")
  },
  {
    name: "users-set-password",
    path: "/users/set-password",
    meta: set_45passwordhAyinGqJe61S3rMqA78CT5LtdT48Msc3_2orC7gagNsMeta || {},
    component: () => import("/app/frontend/src/pages/users/set-password.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index27N45u_45ujOyP0JnEvmiU8FEzaYL1GtgQ1Kr3bQhpPwkMeta || {},
    component: () => import("/app/frontend/src/pages/(landingpage)/index.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricingk0K7K0MYjPIGInwKT0Iru4GMKhSWpip2SCGoVvfcdmEMeta || {},
    component: () => import("/app/frontend/src/pages/(landingpage)/pricing.vue")
  },
  {
    name: "login-forgot-password",
    path: "/login/forgot-password",
    meta: forgot_45passwordN2UHbbAsrzjdqpR_45N29wbv_45NBoEHO_IW9h8axX9eI9UMeta || {},
    component: () => import("/app/frontend/src/pages/login/forgot-password.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexNnaILO72VcAvhXGDi84sJpjuKNbOJH5OEqjsWS7k944Meta || {},
    component: () => import("/app/frontend/src/pages/(landingpage)/signup/index.vue")
  },
  {
    name: "leakprofiles-leakprofileId",
    path: "/leakprofiles/:leakprofileId()",
    component: () => import("/app/frontend/src/pages/leakprofiles/[leakprofileId]/index.vue")
  },
  {
    name: "leakprofiles-leakprofileId-reports",
    path: "/leakprofiles/:leakprofileId()/reports",
    component: () => import("/app/frontend/src/pages/leakprofiles/[leakprofileId]/reports.vue")
  },
  {
    name: "leakprofiles-leakprofileId-accounts",
    path: "/leakprofiles/:leakprofileId()/accounts",
    component: () => import("/app/frontend/src/pages/leakprofiles/[leakprofileId]/accounts.vue")
  },
  {
    name: "leakprofiles-leakprofileId-csveditor",
    path: "/leakprofiles/:leakprofileId()/csveditor",
    component: () => import("/app/frontend/src/pages/leakprofiles/[leakprofileId]/csveditor.vue")
  },
  {
    name: "leakprofiles-leakprofileId-alerts",
    path: "/leakprofiles/:leakprofileId()/alerts",
    component: () => import("/app/frontend/src/pages/leakprofiles/[leakprofileId]/alerts/index.vue")
  },
  {
    name: "signup-terms-of-service-free",
    path: "/signup/terms-of-service-free",
    meta: terms_45of_45service_45free_OPmlhbDawoRoAlZOQcYdfWwvWt6wJBXghbVru7AsAQMeta || {},
    component: () => import("/app/frontend/src/pages/(landingpage)/signup/terms-of-service-free.vue")
  },
  {
    name: "leakprofiles-leakprofileId-alerts-alertId",
    path: "/leakprofiles/:leakprofileId()/alerts/:alertId()",
    component: () => import("/app/frontend/src/pages/leakprofiles/[leakprofileId]/alerts/[alertId].vue")
  },
  {
    name: "leakprofiles-leakprofileId-alerts-unsubscribe",
    path: "/leakprofiles/:leakprofileId()/alerts/unsubscribe",
    meta: unsubscribeXQ0njCTFBwYiKUUXXfi5YwV8KBdJYQsEVZNnu4hdaFIMeta || {},
    component: () => import("/app/frontend/src/pages/leakprofiles/[leakprofileId]/alerts/unsubscribe.vue")
  }
]